var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"info text-primary d-print-none"},[_c('a',{attrs:{"id":_vm.id,"tabindex":"-1","href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"fas fa-info-circle"})]),_c('b-popover',{attrs:{"target":_vm.id,"title":_vm.title,"triggers":"focus hover"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }